export const sideNavigationState = ({ data, component } = {}) => {
  if (!data) {
    return false;
  }

  return {
    data,
    component,
  };
};
